import { createStyles } from 'antd-style';

import abstractBackground from '../resources/img/abstract-background.jpg';
import { ThemeColors, ThemeSpaces } from '../theme';
import { absolute, spaceBetween } from '../styles/mixins';
import { responsiveMdVsLgVsXl } from '../styles/responsiveMixins';

export const useNonLoggedPageStyles = createStyles(
  ({ token }, { view } = {}) => ({
    root: {
      ...absolute(),

      '&::before': {
        content: "' '",
        ...absolute(),
        opacity: 0.65,
        backgroundImage: `url('${abstractBackground}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundColor: ThemeColors.COLOR_WHITE3,
      },
    },
    content: {
      width: '100%',
      height: '100%',
      minWidth: token.screenXSMin,
      display: 'flex',
      flexDirection: 'column',
      padding: `0 ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,

      [`@media (max-width: ${token.screenLGMax}px)`]: {
        padding: ThemeSpaces.SPACE_NORM,
      },
    },
    innerContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'initial',
      margin: `${ThemeSpaces.SPACE_NORM}px 0`,

      [`> * > .${view}`]: {
        display: 'flex',
        flexDirection: 'column',
      },

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenLGMax}px)`]:
        {
          justifyContent: 'flex-start',
          margin: `${ThemeSpaces.SPACE_NORM_30}px ${ThemeSpaces.SPACE_NORM}px`,
        },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        justifyContent: 'flex-start',
        margin: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
      },
    },
    scrollContent: {
      margin: 'auto 0',
      display: 'flex',
      flexDirection: 'column',
    },
    columns: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',

      [`@media (max-width: ${token.screenSMMax}px)`]: {
        flex: 1,
      },

      '> *': {
        ...responsiveMdVsLgVsXl(
          spaceBetween(ThemeSpaces.SPACE_NORM_20),
          spaceBetween(ThemeSpaces.SPACE_NORM_30),
          spaceBetween(ThemeSpaces.SPACE_XL)
        ),
      },
    },
    scrollContentCentered: {
      alignItems: 'center',
    },
    loginPageColumns: {
      '> *': {
        [`@media (min-width: ${token.screenXLMin}px)`]: { height: 485 },
        [`@media (min-width: ${token.screenLGMin}px) and (max-width: ${token.screenLGMax}px)`]:
          { height: 420 },
        [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
          { height: 390 },
      },
    },
  })
);
